import CryptoJS from 'crypto-js';

// Secret keys - match exactly with PHP
const SECRET_KEY = 'Maddy33225@$#Mihir1901@$#Mihir191192@$#)(*&^%!';
const SECRET_IV = 'bgsdhzfgjhfvhasdvfjkvbsdfgsd5fg4df56g45sdfa4ewr5t53454354356454*^&^&%%^#%$#@%';

// Generate key and IV to match PHP implementation
const key = CryptoJS.SHA256(SECRET_KEY).toString();
const iv = CryptoJS.SHA256(SECRET_IV).toString().substring(0, 16);

const mySimpleCrypt = (string, action) => {
  if (!string) {
    console.error('Input string is empty');
    return '';
  }

  try {
    if (action === 'e') {
      // Encryption - using the same format as PHP's openssl_encrypt
      const encrypted = CryptoJS.AES.encrypt(string, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      
      return encrypted.toString();
    } 
    
    if (action === 'd') {
      try {
        // Debug input
        console.log('Decryption input:', {
          string,
          keyLength: key.length,
          ivLength: iv.length,
        });

        // Direct decryption of base64 string
        const decrypted = CryptoJS.AES.decrypt(
          string,
          CryptoJS.enc.Utf8.parse(key),
          {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          },
        );

        const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);

        // Detailed debug output
        console.log('Decryption result:', {
          rawDecrypted: decrypted,
          decryptedHex: CryptoJS.enc.Hex.stringify(decrypted),
          finalString: decryptedString,
        });

        if (!decryptedString) {
          throw new Error('Decryption produced empty result');
        }

        return decryptedString;
      } catch (decryptError) {
        console.error('Decryption error:', {
          message: decryptError.message,
          input: string,
          keyHex: CryptoJS.enc.Hex.stringify(CryptoJS.enc.Utf8.parse(key)),
          ivHex: CryptoJS.enc.Hex.stringify(CryptoJS.enc.Utf8.parse(iv)),
        });
        return '';
      }
    }
    return '';
  } catch (error) {
    console.error('Operation error:', error);
    return '';
  }
};

// Test function
export const testCrypto = () => {
  // Test both encryption and decryption
  const testString = 'Hello World';
  console.log('Original:', testString);

  const encrypted = mySimpleCrypt(testString, 'e');
  console.log('Encrypted:', encrypted);

  const decrypted = mySimpleCrypt(encrypted, 'd');
  console.log('Decrypted:', decrypted);

  return decrypted === testString;
};

export default mySimpleCrypt;
